import { api } from '../api';

export interface RefreshAccessTokenRequest {
    client: string
}

export interface LogoutResponse {
    logoutUrl: string
}

export const AuthApi = {
    refreshAccessToken: (refreshTokenRequest: RefreshAccessTokenRequest) => api.post<any, typeof refreshTokenRequest>('/api/auth/refresh', refreshTokenRequest),
    logout: () => api.post<LogoutResponse>('/api/auth/logout', {}),
    returnFromImpersonation: (returnToken: string) => api.post<{ loginUrl: string }, { returnToken: string }>('/api/auth/return-from-impersonation', { returnToken }),
};
